import { useFundHoldings } from '@apps/savings-overview/react-query/query/use-fund-holdings';
import { useMySavingsAccounts } from '@apps/savings-overview/react-query/query/use-my-savings-accounts';
import { useSavingsAgreementsAccounts } from '@apps/savings-overview/react-query/query/use-savings-agreements-accounts';
import { IconTypes } from '@eika/icon';
export const useSavingsEncouragement = () => {
    const { data: savingsAccountsData } = useMySavingsAccounts();
    const { mySavingsAccounts: savingsAccounts } = savingsAccountsData;
    const { data: savingsAgreementsAccountsData } = useSavingsAgreementsAccounts();
    const { totalMonthlyAmount: totalMonthlyAmountAccounts, nextPaymentDate: nextPaymentDateAccounts } = savingsAgreementsAccountsData || {};
    const { data: holdingsData } = useFundHoldings();
    const { holdingsCount } = holdingsData;
    if (savingsAccounts.length === 0 && holdingsCount === 0) {
        return {
            holdingsCount,
            data: {
                scenario: 'NO_SAVINGS_PRODUCTS',
                icon: IconTypes.SPAREGRIS_24,
                action: 'FIND_SAVINGS_PRODUCT',
            },
        };
    }
    if (savingsAccounts.length > 0 && holdingsCount === 0) {
        return {
            holdingsCount,
            data: {
                scenario: 'ACCOUNT_NO_FUNDS',
                icon: IconTypes.GRAFLINJE_36,
                action: 'VIEW_FUNDS',
            },
        };
    }
    if (savingsAccounts.length > 0 &&
        holdingsCount > 0 &&
        (totalMonthlyAmountAccounts === 0 || !nextPaymentDateAccounts)) {
        return {
            holdingsCount,
            data: {
                scenario: 'ACCOUNT_FUNDS_NO_AGREEMENTS',
                icon: IconTypes.KALENDER_36,
                action: 'START_SAVING_AGREEMENT',
            },
        };
    }
    if (totalMonthlyAmountAccounts !== 0 && nextPaymentDateAccounts && holdingsCount > 0) {
        return {
            holdingsCount,
            data: {
                scenario: 'ACCOUNT_FUNDS_AGREEMENTS',
                icon: IconTypes.VERDI_36,
                action: 'INCREASE_SAVINGS_AMOUNT',
            },
        };
    }
    return {
        holdingsCount,
        data: {
            scenario: 'ACCOUNT_FUNDS_NO_AGREEMENTS',
            icon: IconTypes.KALENDER_24,
            action: 'START_SAVING_AGREEMENT',
        },
    };
};
//# sourceMappingURL=data:application/json;base64,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